import { reqPost } from 'HttpRequests'

interface IClosePaymentResponse {
  pay_sum: number
  status: string
  status_message: string
}

function reqStartPayment(orderId: number, callback: (login?: string) => void) {
  reqPost('api/start_payment/', { orderId }, (response) => callback(response.login))
}

function reqClosePayment(
  orderId: number,
  system: string,
  externOrderId: string,
  callback: (response: IClosePaymentResponse) => void
) {
  reqPost('api/close_payment/', { orderId, system, externOrderId }, callback)
}

export { reqStartPayment, reqClosePayment }
